var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 510,
    height: 541,
    viewBox: "0 0 510 541",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_2437_10530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.64732 79.6357C10.5736 36.4508 47.6933 2.9723 90.7444 6.49371L259.977 20.3363L429.647 13.763C472.809 12.0909 508.459 47.1303 507.533 90.3152L504.207 245.375L500.195 432.422C499.417 468.69 472.793 499.202 436.964 504.887L260.089 532.95C252.7 534.122 245.177 534.182 237.771 533.128L66.4868 508.755C28.9138 503.408 1.25622 470.837 2.07007 432.894L6.32134 234.696L9.64732 79.6357Z",
    stroke: "url(#paint0_linear_2437_10530)",
    strokeWidth: 2.25,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "10.5 10.5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2437_10530",
    x1: 260.298,
    y1: 5.33972,
    x2: 248.943,
    y2: 534.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#834D8E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.798364,
    stopColor: "#834D8E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2437_10530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 509.24,
    height: 540.058,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashes);
export default __webpack_public_path__ + "static/media/dashes.97212e488c248f5d971c46a19cbb338c.svg";
export { ForwardRef as ReactComponent };